module.exports = __webpack_public_path__ + "img/Madison Liistro.003e581c.jpg";